import styled from "@yb/styled-px2rem";

const Text = styled.p`
	display: block;
	margin-top: 5px;
	font-size: 12px;
	color: var(--red-color);
	line-height: 1.6;
`;

const RequiredText = ({children}) => <Text>{children}</Text>;

export default RequiredText;
